import { render, staticRenderFns } from "./benzol.vue?vue&type=template&id=52ff3a2e&"
import script from "./benzol.vue?vue&type=script&lang=js&"
export * from "./benzol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports